import { useMutation } from "react-query";
import { useConfig } from "../../utils/useConfig";
import { useData } from "../../utils/useData";
import { EmployeeAccount } from "../../models";
import { getSafeSessionConfig } from "../utils/getSafeSessionConfig";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { topUpAccount } from "../../mutations/accounts/topUpAccount";
import { toast } from "react-toastify";

export const useTopUpAccount = ( options?: {
    onSuccess?: () => void;
    onError?: (error: Error) => void;
}) => {
  const { config } = useConfig();
  const { getToken } = useKindeAuth();
  const { employerId, employees, accounts } = useData();

  return useMutation(
    async ({ selectedAccount, amount }: { selectedAccount: EmployeeAccount, amount: number }) => {
        const { API_URL, token } = await getSafeSessionConfig(config, getToken);
        await topUpAccount(API_URL, token, employerId, selectedAccount.employeeId, selectedAccount.id, amount);
    },
    {
        onSuccess: () => {
            toast.success("Account topped up!");
            employees.refetch();
            accounts.refetch();      
            options?.onSuccess?.();
        },
        onError: (error: Error) => {
            toast.error("There was a problem topping up this account.");
            options?.onError?.(error);
        }
    }
  )  
};
